import Vue from 'vue'

// axios
import axios from 'axios'
import config from '@core/app-config/api-config'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: config.host,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
